import type { UserRole } from "./types";

// Contrato de acesso CCB v1.0.0 (specs/004-acesso-central/contracts/claims-acesso.md):
// o papel vem do custom claim `apps.docs`, gravado só pelo portal Acesso CCB.
// Espelha firestore.rules: a regra decide; estas funções só ajustam a interface.
export const APP_ID = "docs";
export const APP_NAME = "Documentação CCB BH";
export const ACCESS_PORTAL_HOST = "acesso.ccbbh.com.br";
export const ACCESS_PORTAL_URL = `https://${ACCESS_PORTAL_HOST}`;
export const ROLES: UserRole[] = ["admin", "editor", "reader"];
export const ROLE_LABEL: Record<UserRole, string> = { admin: "Administrador", editor: "Editor", reader: "Leitor" };

export type Access = { kind: "granted"; role: UserRole } | { kind: "denied" };

/** Papel do app no claim `apps`; ausência, formato inválido ou papel fora do catálogo = sem acesso. */
export function roleFromClaims(claims: Record<string, unknown> | null | undefined): UserRole | null {
  const apps = claims?.apps;
  if (!apps || typeof apps !== "object" || Array.isArray(apps)) return null;
  const role = (apps as Record<string, unknown>)[APP_ID];
  return typeof role === "string" && (ROLES as string[]).includes(role) ? (role as UserRole) : null;
}

export function resolveAccess(claims: Record<string, unknown> | null | undefined): Access {
  const role = roleFromClaims(claims);
  return role ? { kind: "granted", role } : { kind: "denied" };
}

export function canEdit(role: UserRole) { return role === "admin" || role === "editor"; }
